import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";
import profilePic from "../assets/img/profilePic.jpg";

export const Newsletter = ({ status, message, onValidated }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);

  const clearFields = () => {
    setEmail("");
  };

  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp">
        <Row>
          <Col lg={12} md={6} xl={5}>
            <div className="profile-photo">
              <img
                src={profilePic}
                alt="Your Name"
                style={{
                  filter: "grayscale(100%)",
                }}
              />
            </div>
            {status === "sending" && <Alert>Sending...</Alert>}
            {status === "error" && <Alert variant="danger">{message}</Alert>}
            {status === "success" && <Alert variant="success">{message}</Alert>}
          </Col>
          <Col md={6} xl={7}>
            <h3>
              You can reach me at<br></br>
            </h3>
            Email : sajinapathak0@gmail.com
            <br></br>
            Resides in: Palm Bay, Florida, USA{" "}
            <span style={{ fontSize: "2.5em" }}>🇺🇸</span>
            &nbsp; &nbsp; Originally from
            <span style={{ fontSize: "3em" }}>🇳🇵</span>
            <br></br> Aim higher ~<br></br>~ You can accomplish anything you
            dream, so dare to dream bigger.
            {/* <Button
              variant="primary"
              href="/path-to-your-cv.pdf"
              target="_blank"
              download
              style={{ marginTop: "10px" }}
            >
              Download CV
            </Button> */}
          </Col>
        </Row>
      </div>
    </Col>
  );
};
